<template>
<el-table :data="tableData" style="width: 100%" @row-click="handleRowClick">
    <el-table-column prop="provider" label="cedente" min-width="120">
        <template slot-scope="scope">
            <el-tooltip class="item" :content="scope.row.name | formatName" placement="top">
                <div class="col d-flex justify-content-start align-items-center col-1-body">
                    <div>
                        <NameInitials :name="scope.row.tradingName || scope.row.name" small />
                    </div>
                    <p class="break d-inline-block d-flex align-items-center medium c-ndarkfour">
                        {{ (scope.row.tradingName || scope.row.name) | formatName }}
                    </p>
                </div>
            </el-tooltip>
        </template>
    </el-table-column>

    <el-table-column prop="cnpj" label="cnpj" min-width="80">
        <template slot-scope="scope">
            <p class="medium c-ndarkfour">
                {{ scope.row.cnpj.cnpj | formatCnpjOrCpf }}
            </p>
        </template>
    </el-table-column>

    <el-table-column prop="state" min-width="80">
        <template slot="header">
            <div class="row align-items-center">
                <div class="cell ml-2" >Sócio com E-CPF</div>
                <el-tooltip class="item" placement="top" >
                    <template slot="content">
                        <span>
                            Indica se pelo menos um<br> 
                            dos sócios da empresa<br> 
                            possui e-CPF
                        </span>
                    </template>
                    <Interrogation />
                </el-tooltip>
            </div>
        </template>
        <template slot-scope="scope">
            <p class="medium c-ndarkfour">
                <eCPFStatus :text="renderECpf(scope.row)" />
            </p>
        </template>
    </el-table-column>

    <el-table-column prop="createdAt" label="Início das..." min-width="80">
        <template slot="header">
            <el-tooltip class="item" content="Início das operações" placement="top" >
                <div class="cell teste" >
                    Início das...
                </div>
            </el-tooltip>
        </template>
        <template slot-scope="scope">
            <p class="medium c-ndarkfour"> 
                {{ scope.row.createdAt | formatDate }}
            </p>
        </template>
    </el-table-column>

    <el-table-column prop="totalValue" label="Total em notas" min-width="80">
        <template slot-scope="scope">
            <p class="medium c-greenfour">
                R$ {{ scope.row.totalValue | formatMoney }}
            </p>
        </template>
    </el-table-column>

    <el-table-column prop="orderFomentationRequest" min-width="80">
        <template slot-scope="scope">
            <el-dropdown trigger="click">
                <Button :color="getPrimaryColor" type="secondary" size="small">Ações</Button>
                <el-dropdown-menu slot="dropdown">
                    <ActionBtnItemsContainerVue :withoutBottomLine="false">
                        <el-dropdown-item>
                            <el-dropdown placement="left-start" :show-timeout="0" class="d-flex">
                                <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center">
                                    <CompanyIcon size="16" color="#A1A8B8" class="mr-2" />Classificar cadastro
                                    <ArrowDropdown class="ml-5" color="#A1A8B8" rotate="270"/>
                                </span>
                                <el-dropdown-menu slot="dropdown" class="mt-n2">
                                    <el-dropdown-item>
                                        <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClassificationChange(scope.row, 0)" :style="isRejected(scope.row) ? null : 'pointer-events: none;'">
                                            <CheckPayment size="18" color="#A1A8B8" :style="isRejected(scope.row) ? 'visibility: hidden;' : null" />
                                            <span class="ml-1">Aprovar</span>
                                        </span>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClassificationChange(scope.row, 1)" :style="!isRejected(scope.row) ? null : 'pointer-events: none;'">
                                            <CheckPayment size="18" color="#A1A8B8" :style="!isRejected(scope.row) ? 'visibility: hidden;' : null" />
                                            <span class="ml-1">Reprovar</span>
                                        </span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </el-dropdown-item>
                    </ActionBtnItemsContainerVue>

                    <ActionBtnItemsContainerVue :withoutBottomLine="false">
                        <el-dropdown-item>
                            <span 
                                class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center" 
                                @click="downloadAll(scope.row.id)"
                            >
                                <Download size="16" color="#A1A8B8" class="mr-2"/>Baixar todos documentos
                            </span>
                        </el-dropdown-item>
                    </ActionBtnItemsContainerVue>
                    <ActionBtnItemsContainerVue :withoutBottomLine="true">
                        <el-dropdown-item>
                            <span 
                                class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center" 
                                @click="goToDetails(scope)"
                            >
                                <DetailsFile size="16" color="#A1A8B8" class="mr-2"/>Ver detalhes do cedente
                            </span>
                        </el-dropdown-item>
                    </ActionBtnItemsContainerVue>
                </el-dropdown-menu>
            </el-dropdown>
        </template>
    </el-table-column>

</el-table>
</template>

<script>
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import CheckPayment from '@/components/icons/CheckPayment'
import NameInitials from '@/components/icons/NameInitials'
import downloadAllFilesProvider from '@/api/downloadAllFilesProvider'
import downloadArchive from '@/api/downloadArchive'
import updateSponsorRejectedProvider from '@/api/updateSponsorRejectedProvider'
import Download from '@/components/icons/Download'
import DetailsFile from '@/components/icons/DetailsFile'
import Interrogation from '@/components/icons/Interrogation'
import ActionBtnItemsContainerVue from '@/components/container/ActionBtnItemsContainer'
import eCPFStatus from '@/components/status/eCPFStatus'

export default {
    props: {
        tableData: {
            required: true
        },
    },
    components: {
        ArrowDropdown,
        CheckPayment,
        NameInitials,
        Download,
        DetailsFile,
        ActionBtnItemsContainerVue,
        Interrogation,
        eCPFStatus,
    },
    methods: {
        renderECpf(provider){
            return provider.eCpf ? 'Sim' : 'Não'
        },
        mapPhoneNumber(phoneNumber) {
            if (phoneNumber) {
                const phone = phoneNumber.replace(/\D/g, '')
                const areaCode = phone.slice(0, 2)
                const prefix = phone.length > 10 ? phone.slice(2, 7) : phone.slice(2, 6)
                const suffix = phone.slice(-4)
                return `(${areaCode}) ${prefix}-${suffix}`
            } else {
                return '-'
            }
        },
        handleRowClick(row, column) {
            if (column.label) this.$router.push(`provider/${row.id}`)
        },
        goToDetails(scope) {
            this.$router.push(`provider/${scope.row.id}`)
        },
        async downloadAll(id) {
            this.$store.commit('user/setIsDownloadLoading', true)

            const result = await downloadAllFilesProvider(id)
            await downloadArchive(`${process.env.VUE_APP_ROOT_API}/${result}`)

            this.$store.commit('user/setIsDownloadLoading', false)
        },
        async handleClassificationChange(row, reject) {
            const notificationText = reject ? 'reprovado' : 'aprovado'
            
            const result = await updateSponsorRejectedProvider({
                providerId: row.id, 
                sponsorCnpjId: this.$store.state.user.cnpjId,
                reject
            })
            
            if (result.ok) {
                this.$emit('classificationChange')
                this.$notify({
                    title: `Cedente ${notificationText} com sucesso.`,
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
            }
        },
        isRejected(scope){
            const [sponsor] = scope.sponsors

            return sponsor.sponsorProvider.rejected
        }
    },
}
</script>

<style scoped>
    .fix-tooltip-provider {
        left: 1084px !important;
    }

    .col-1-body {
        padding-left: 0px !important;
    }
    tr th{
        padding-bottom: 5px !important;
    }

    .teste {
        width: 90px !important;
    }
/* 
    .title-text {
        display: flex !important;
        align-content: center !important;
        align-items: center !important;
    } */
</style>
